// extracted by mini-css-extract-plugin
export default {"statusTag":"src-components-StatusTag-css-module__statusTag--9WA97"};